(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["resources-video-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.rvp');
    if (!section) return;

    var modal = section.querySelector('.rvp__modal');
    if (!modal) return;

    var modalBody = section.querySelector('.rvp__modal-body');
    var modalTitle = section.querySelector('.rvp__modal-title');
    var closeBtn = section.querySelector('.rvp__modal-close');
    var triggerEl = null;

    var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    function handleTrap(e) {
      if (e.key !== 'Tab') return;
      var els = modal.querySelectorAll(FOCUSABLE);
      if (!els.length) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function supportsDialog() {
      return typeof HTMLDialogElement === 'function';
    }

    function closeModal() {
      modal.removeEventListener('keydown', handleTrap);
      document.documentElement.classList.remove('rvp-modal-open');
      if (supportsDialog()) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      modalBody.innerHTML = '';
      if (triggerEl) {
        triggerEl.focus();
        triggerEl = null;
      }
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-vl-play]');
      if (!trigger) return;
      e.preventDefault();
      triggerEl = trigger;
      var ytId = trigger.getAttribute('data-vl-yt-id');
      var title = trigger.getAttribute('data-vl-title');
      modalBody.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' +
        ytId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen title="' +
        title.replace(/"/g, '&quot;') + '"></iframe>';
      modalTitle.textContent = title;
      if (supportsDialog()) {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.classList.add('rvp-modal-open');
      modal.addEventListener('keydown', handleTrap);
      closeBtn.focus();
    });

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.hasAttribute('open')) closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-library"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.vl');
    if (!section) return;

    var modal = section.querySelector('.vl__modal');
    var modalBody = section.querySelector('.vl__modal-body');
    var modalTitle = section.querySelector('.vl__modal-title');
    var closeBtn = section.querySelector('.vl__modal-close');
    var chips = section.querySelectorAll('[data-vl-filter]');
    var cards = section.querySelectorAll('.vl__card');
    var triggerEl = null;
    var statusEl = section.querySelector('[data-vl-status]');
    var sortEl = section.querySelector('[data-vl-sort]');
    var grid = section.querySelector('.vl__grid');
    var originalOrder = Array.from(cards);

    /* ---- Analytics ---- */
    function fireEvent(name, detail) {
      try {
        window.dispatchEvent(new CustomEvent(name, { detail: detail }));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, detail));
        if (typeof fbq === 'function') fbq('trackCustom', name, detail);
      } catch (e) {}
    }

    /* ---- Status + Sort ---- */
    function updateStatus() {
      var n = 0;
      cards.forEach(function (c) { if (!c.hidden) n++; });
      if (statusEl) {
        var tpl = statusEl.getAttribute('data-i18n-showing') || 'Showing __COUNT__ video(s)';
        statusEl.textContent = tpl.replace('__COUNT__', n);
      }
    }

    function sortCards(mode) {
      var arr;
      if (mode === 'az') {
        arr = originalOrder.slice().sort(function (a, b) {
          var ta = a.querySelector('.vl__card-title').textContent.trim().toLowerCase();
          var tb = b.querySelector('.vl__card-title').textContent.trim().toLowerCase();
          return ta < tb ? -1 : ta > tb ? 1 : 0;
        });
      } else if (mode === 'newest') {
        arr = originalOrder.slice().reverse();
      } else {
        arr = originalOrder.slice();
      }
      arr.forEach(function (c) { grid.appendChild(c); });
      updateStatus();
    }

    /* ---- Filtering ---- */
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-vl-filter');
        chips.forEach(function (c) {
          c.classList.remove('vl__chip--active');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('vl__chip--active');
        chip.setAttribute('aria-pressed', 'true');
        cards.forEach(function (card) {
          card.hidden = !(filter === 'all' || card.getAttribute('data-vl-category') === filter);
        });
        sortCards(sortEl ? sortEl.value : 'featured');
        fireEvent('video_library_filter_change', { category: filter });
      });
    });

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sortCards(sortEl.value);
      });
    }

    /* ---- Focus trap ---- */
    var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    function handleTrap(e) {
      if (e.key !== 'Tab') return;
      var els = modal.querySelectorAll(FOCUSABLE);
      if (!els.length) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* ---- Modal ---- */
    function supportsDialog() {
      return typeof HTMLDialogElement === 'function';
    }

    function closeModal() {
      modal.removeEventListener('keydown', handleTrap);
      document.documentElement.classList.remove('vl-modal-open');
      if (supportsDialog()) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      modalBody.innerHTML = '';
      if (triggerEl) {
        triggerEl.focus();
        triggerEl = null;
      }
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-vl-play]');
      if (!trigger) return;
      e.preventDefault();
      triggerEl = trigger;
      var ytId = trigger.getAttribute('data-vl-yt-id');
      var title = trigger.getAttribute('data-vl-title');
      var card = trigger.closest('.vl__card');
      var category = card ? card.getAttribute('data-vl-category') : '';
      modalBody.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' +
        ytId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen title="' +
        title.replace(/"/g, '&quot;') + '"></iframe>';
      modalTitle.textContent = title;
      if (supportsDialog()) {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.classList.add('vl-modal-open');
      modal.addEventListener('keydown', handleTrap);
      closeBtn.focus();
      fireEvent('video_library_watch_click', { video_id: ytId, title: title, category: category });
    });

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.hasAttribute('open')) closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
